import React from 'react';
import { Gift, Flame, ShieldCheck, Zap, Star, Clock } from 'lucide-react';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { CountdownTimer } from '../ui/CountdownTimer';
const CHECKOUT_URL = 'https://ultrapack.digital/cart/48625618714849:1';
const bonos = [{
  title: 'BONO 1 — El Diccionario Secreto de tu Bebé',
  problem: 'Tu bebé ya intenta comunicarse con vos. Solo que todavía no usa palabras.',
  desc: 'Aprendé a interpretar sus gestos, expresiones, miradas y tipos de llanto para entender lo que necesita mucho antes de que pueda decirlo.',
  result: 'Vas a entender mejor a tu bebé incluso antes de sus primeras palabras.'
}, {
  title: 'BONO 2 — Método Pantallas Cero',
  problem: 'Cuando no sabés qué hacer, el celular termina siendo la salida más fácil.',
  desc: 'Descubrí un plan práctico para reducir las pantallas sin berrinches, reemplazándolas por actividades simples que realmente mantienen a tu hijo entretenido.',
  result: 'Vas a dejar de depender del celular para entretener a tu hijo.'
}, {
  title: 'BONO 3 — Guía de Supervivencia Familiar',
  problem: 'Todos opinan sobre tu hijo... aunque nadie esté en tu lugar.',
  desc: 'Aprendé a responder con tranquilidad a las comparaciones y comentarios de familiares, y descubrí cómo convertirlos en aliados del desarrollo del habla.',
  result: 'Vas a sentirte mucho más segura frente a las opiniones de los demás.'
}, {
  title: 'BONO 4 — Comer, Hablar y Jugar',
  problem: 'El desarrollo del habla también empieza por la boca.',
  desc: 'Descubrí juegos simples de soplido, masticación y movimiento que fortalecen las habilidades orales de forma divertida y natural.',
  result: 'Vas a complementar la estimulación del habla con actividades que fortalecen sus bases.'
}, {
  title: 'BONO 5 — Jardín sin Miedo',
  problem: 'El primer día de jardín es mucho más fácil cuando un niño sabe comunicarse.',
  desc: 'Prepará a tu hijo para expresar lo que necesita, pedir ayuda y relacionarse con mayor seguridad antes de empezar esta nueva etapa.',
  result: 'Vas a ayudar a que llegue al jardín con más confianza para comunicarse.'
}, {
  title: 'BONO 6 — Diario del Desarrollo del Habla',
  problem: 'Los primeros avances pasan muy rápido... y merecen ser recordados.',
  desc: 'Registrá cada palabra, cada hito y cada logro del desarrollo del lenguaje en una bitácora que también te servirá para seguir su evolución.',
  result: 'Vas a conservar un recuerdo único mientras seguís de cerca el progreso de tu hijo.'
}];
export function Bonuses() {
  return <section className="py-12 px-5 bg-violet-50" data-id="element-33">
      <div className="text-center mb-10" data-id="element-34">
        <div className="inline-flex items-center justify-center bg-violet-200 p-3 rounded-full mb-4" data-id="element-35">
          <Gift className="w-8 h-8 text-violet-700" data-id="element-36" />
        </div>
        <h2 className="text-3xl font-extrabold text-gray-900 mb-4" data-id="element-37">
          Y eso no es todo.
        </h2>
        <p className="text-lg text-gray-700" data-id="element-38">
          Si comprás el Ultrapack hoy, recibís estos{' '}
          <span className="font-bold text-violet-700" data-id="element-39">
            6 bonos sin costo adicional
          </span>
          :
        </p>
      </div>

      <div className="space-y-6 mb-12" data-id="element-40">
        {bonos.map((bono, index) => <Reveal key={index} delay={Math.min(index * 0.05, 0.25)} data-id="element-41">
            <div className="bg-white rounded-2xl p-6 shadow-sm border-2 border-violet-100 relative overflow-hidden transition-shadow hover:shadow-md" data-id="element-42">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-43">
                GRATIS
              </div>
              <h3 className="font-bold text-xl text-gray-900 mb-4 pr-20 mt-2" data-id="element-44">
                {bono.title}
              </h3>

              <p className="text-gray-700 text-sm italic mb-4" data-id="element-45">
                "{bono.problem}"
              </p>

              <p className="text-gray-600 text-sm mb-4 leading-relaxed" data-id="element-46">
                {bono.desc}
              </p>

              <div className="bg-violet-50 p-3 rounded-lg border border-violet-100" data-id="element-47">
                <p className="text-sm font-bold text-violet-800" data-id="element-48">
                  ✨ {bono.result}
                </p>
              </div>
            </div>
          </Reveal>)}
      </div>

      {/* Purchase section */}
      <Reveal data-id="element-49">
        <div id="comprar" className="scroll-mt-6 bg-white rounded-3xl shadow-2xl border-2 border-violet-300 overflow-hidden" data-id="element-50">
          {/* Offer counter banner */}
          <div className="bg-rose-500 text-white text-center py-4 px-4" data-id="element-51">
            <div className="flex items-center justify-center gap-2 font-extrabold text-sm sm:text-base uppercase tracking-wide mb-2" data-id="element-52">
              <Flame className="w-5 h-5 text-amber-200 animate-pulse" data-id="element-53" />
              🎁 Oferta 70% OFF · Solo 20 cupos
            </div>
            <div className="flex items-center justify-center gap-2 text-sm" data-id="element-54">
              <span className="flex items-center gap-1 font-medium text-rose-50" data-id="element-55">
                <Clock className="w-4 h-4" data-id="element-56" /> La oferta termina en
              </span>
              <CountdownTimer minutes={17} className="text-lg" data-id="element-57" />
            </div>
          </div>

          <div className="p-6" data-id="element-58">
            <h4 className="text-xl font-bold text-center mb-6 text-gray-900" data-id="element-59">
              Resumen de lo que recibís:
            </h4>

            <div className="space-y-3 text-sm mb-6" data-id="element-60">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-61">
                <span className="font-medium text-gray-700" data-id="element-62">
                  Los 6 Tomos del Ultrapack
                </span>
                <span className="text-gray-400 line-through" data-id="element-63">$45.000</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-64">
                <span className="font-medium text-gray-700" data-id="element-65">Bonos 1 al 6</span>
                <span className="text-gray-400 line-through" data-id="element-66">$39.000</span>
              </div>
              <div className="flex justify-between items-center pt-2" data-id="element-67">
                <span className="font-bold text-gray-900" data-id="element-68">VALOR TOTAL</span>
                <span className="font-bold text-gray-400 line-through" data-id="element-69">
                  $84.000
                </span>
              </div>
            </div>

            <div className="text-center bg-violet-100 rounded-2xl p-5 mb-6 border border-violet-200" data-id="element-70">
              <p className="text-sm font-bold text-violet-600 uppercase tracking-wider mb-1" data-id="element-71">
                Hoy lo llevás por solo
              </p>
              <p className="text-5xl font-extrabold text-violet-900 leading-none" data-id="element-72">
                $23.990
              </p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-73">
                Valor real <span className="line-through" data-id="element-74">$84.000</span> ·{' '}
                <span className="font-bold text-rose-500" data-id="element-75">70% OFF</span>
              </p>
            </div>

            <Button variant="green" href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" data-id="element-76">
              <span className="text-lg" data-id="element-77">
                ✅ QUIERO EL ULTRAPACK Y LOS BONOS
              </span>
            </Button>

            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-gray-500 font-medium mt-4" data-id="element-78">
              <span className="flex items-center gap-1" data-id="element-79">
                <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-80" /> Garantía 7
                días
              </span>
              <span className="flex items-center gap-1" data-id="element-81">
                <Zap className="w-4 h-4 text-amber-500" data-id="element-82" /> Acceso inmediato
              </span>
            </div>

            <p className="flex items-center justify-center gap-1 text-xs text-violet-500 font-semibold mt-3" data-id="element-83">
              <Star className="w-3.5 h-3.5 fill-violet-400 text-violet-400" data-id="element-84" />
              +4.372 descargas
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}